import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import index from '@/views/index/index'
import detail from '@/views/index/detail'
import trial from '@/views/trial/index'
import password from '@/views/set-up/password'
import user from '@/views/user/index'
import pdf from '@/views/trial/pdf'

Vue.use(Router)
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: [
    {
      path: '/',
      name: 'report_hall',
      component: index
    }, {
      path: '/detail',
      name: 'detail',
      component: detail,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/trial',
      name: 'trial',
      component: trial,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/password',
      name: 'password',
      component: password,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/user',
      name: 'user',
      component: user,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/pdf',
      name: 'pdf',
      component: pdf,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld,
      meta: {
        requireAuth: true
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js